import React from 'react'
import { Stack } from 'react-bootstrap'
import classNames from 'classnames'
import { RadioCard } from '../../Components/RadioCard'
import styles from '../CrmPostConnectSettings.module.scss'
import { type RadioControlCopy } from '../../../copies/contactSyncCopy'

export interface ContactSyncAdminControlProps {
  copy: RadioControlCopy
  contactSync: boolean
  onChange: (enabled: boolean) => void
}

export const ContactSyncAdminControl: React.FC<ContactSyncAdminControlProps> = ({ copy, contactSync, onChange }) => (
  <div className={classNames(styles.settingCard, 'border')}>
    <div className='fw-semibold mb-2'>Sync contacts</div>
    <Stack gap={2}>
      <RadioCard
        id='contact-sync-off'
        name='contactSync'
        value='off'
        checked={!contactSync}
        label={copy.off.label}
        description={copy.off.description}
        onChange={() => onChange(false)}
      />
      <RadioCard
        id='contact-sync-on'
        name='contactSync'
        value='on'
        checked={contactSync}
        label={copy.on.label}
        description={copy.on.description}
        warning={copy.onWarning}
        onChange={() => onChange(true)}
      />
    </Stack>
  </div>
)
